import { BrowserRouter, Route, Routes } from 'react-router-dom';
import React from 'react';
import './App.css';
import Navbar from './Components/Navbar/Navbar';
import Product from './Pages/Product';
import Cart from './Pages/Cart';
import Shop from './Pages/Shop';
import ShopCategory from './Pages/ShopCategory';
import LoginSignup from './Pages/LoginSignup';
import Footer from './Components/Footer/Footer';
import GuardedRoute from './Pages/GuardedRoute';
import 'bootstrap/dist/css/bootstrap.min.css';
import Order from './Pages/Order';
import TermsAndConditions from "./Pages/TermsAndConditions";
import MyOrders from './Pages/MyOrders';


function App() {

  return (
    <div className="App">
      <BrowserRouter>
        <Navbar></Navbar>
         {/* Add the CarouselComponent here to display on top of your routes */}
         {/* <Hero /> */}
        <Routes>
          <Route path="/" element={<Shop/>}></Route>
          <Route path="/grocery" element={<ShopCategory category="grocery"/>}></Route>
          <Route path="/spices" element={<ShopCategory category="spices"/>}></Route>
          <Route path="/beverages" element={<ShopCategory category="beverages"/>}></Route>
          <Route path="/ricemix" element={<ShopCategory category="ricemix"/>}></Route>
          <Route path="/misc" element={<ShopCategory category="misc"/>}></Route>
          <Route path="/product" element={<Product/>}>
            <Route path=":productId" element={<Product/>}></Route>
          </Route>
          <Route path="/cart" element={<Cart/>}></Route>
          <Route path="/order" element={<Order/>}></Route> 
          <Route element={<GuardedRoute/>}>
            <Route path="/myorders" element={<MyOrders/>}></Route>
          </Route>
          {/* <Route path="/login" element={<LoginSignup/>}></Route> */}
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        </Routes>
        <Footer/>
      </BrowserRouter>
    </div>
  );
}

export default App;
